import { GridBaseDataProvider } from '../../../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys } from '../types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../../../grid/types/common';
import { sanitizeObject } from '../../../../../utils/sanitization.utils';
import { v4 as uuidv4 } from 'uuid';
import { AtlassianJiraConfluenceSensorDetails } from '../../atlassianJiraConfluence/types';

export class AtlassianJiraConfluenceGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private items: Array<AtlassianJiraConfluenceSensorDetails> = [];

  constructor(public dependencies: any) {
    super();
  }

  public setData(data: Array<AtlassianJiraConfluenceSensorDetails>): void {
    this.items = data
      .filter(item => item._id !== '')
      .map(item => {
        item.actions = 'actions';
        return item;
      });
  }

  public getData(): Array<AtlassianJiraConfluenceSensorDetails> {
    return this.items;
  }

  public deleteItem(id: string): void {
    this.items = this.items.filter(item => item._id !== id);
  }

  public async addToList(row: AtlassianJiraConfluenceSensorDetails): Promise<void> {
    row._id = uuidv4();
    row.actions = 'actions';
    this.items.unshift(row);
  }

  public async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    const summary = this.items.length;

    return sanitizeObject({
      summary: summary + ' ' + this.dependencies.translateFn('items'),
      numItems: summary,
    });
  }

  public async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    if (request.pageNumber && request.pageSize) {
      const start = (request.pageNumber - 1) * request.pageSize;
      const end = start + request.pageSize;

      return sanitizeObject({ rawEvents: this.items.slice(start, end) });
    }

    return sanitizeObject({ rawEvents: this.items });
  }

  public async setFilters(request): Promise<{} | undefined> {
    return;
  }

  public async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }
}
